import { taskForms as actionTypes } from '$constants/action-types';

export const fetchAll = (projectId) => ({
  type: actionTypes.FETCH_ALL,
  projectId
});

export const fetchAllSuccess = result => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result
});



// WEBPACK FOOTER //
// ./src/actions/task-forms.js